// ---------------------------------------------------------------
// Collection page
// ---------------------------------------------------------------

// This file loads via a plain <script defer>, which runs at DOMContentLoaded -
// before custom.js, which only loads on the first user interaction (or on
// window 'load' after an idle/timeout fallback). html_tag and root_styles are
// custom.js globals; referencing them here unguarded threw a ReferenceError on
// this script's very first statement and aborted the entire file before any
// filter handler below ever registered - the drawer opened (that part is
// custom-async.js's generic panel code, independent of this file) but nothing
// inside it responded to a click or a checkbox: it looked frozen.
// var, not let/const: custom.js's own declarations for these two are inside a
// dead if-branch and never actually bind at top level (see custom.js:1-10), so
// there is nothing here to collide with regardless of which script runs first.
if (typeof html_tag === 'undefined') { var html_tag = document.documentElement; }
if (typeof root_styles === 'undefined') { var root_styles = document.querySelector(':root'); }

// custom.js
// -----------------------------------------------

// Adds 'in-col' class to slider elements inside module containers, except those with excluded width classes.
// Looked up locally rather than through custom.js's module_collection: that is
// a top-level `let` there, and re-declaring the same name here would be a
// SyntaxError if custom.js happens to load first.
Array.from(document.getElementsByClassName('m6cl')).forEach(container => {
	Array.from(container.querySelectorAll('.l4cl.slider:not(.w12, .w14, .w16, .w20, .w25, .w33, .w50)')).forEach(element => {
		element.classList.add('in-col');
	});
});



// custom-async.js
// -----------------------------------------------
// Grid or list view
var saveCollectionview = function(attribute, value) {
	const config = {
		method: 'POST',
		body: JSON.stringify({
			attributes: {
				[attribute]: value
			}
		}),
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
			'Content-Type': 'application/json',
			'Accept': 'application/javascript'
		}
	};
	fetch(routes.cart_update_url, config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					handleErrorMessage(response.description);
					return;
				}
			})
			.catch((error) => {
				console.log("saveCollectionview error", error);
			});
}

function insertAfter(referenceNode, newNode) {
	referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function saveLoadMoreAnchor() {
	let anchors = document.querySelectorAll('#collection > li > figure > a, .m6cl .results > div a, .m6cl .results > .l4ne a');
	if (anchors) {
		Array.from(anchors).forEach(function (el) {
			el.addEventListener('click', function(e) {
				localStorage.setItem('loadMoreItemClicked', el.getAttribute('href'));
			});
		});
	}
}

// Attaches click handlers to aside navigation toggle links, calling toggle_dropdowns_simple() on their parent element.  
const navAsideEvt = new CustomEvent("navAside")
window.addEventListener("navAside", function(evt) {
	const nav_aside = document.querySelectorAll('.n6as a.toggle:not(.n6as-initalized)');
	if (nav_aside.length) {
		nav_aside.forEach(function (el) {
			el.classList.add('n6as-initalized');
			el.addEventListener('click', function (e) {
				toggle_dropdowns_simple(el.parentElement);
				e.preventDefault();
			});
		});
	}
});
window.dispatchEvent(navAsideEvt);

// ---------------------------------------------------------------
// Filter drawer
// ---------------------------------------------------------------
// Built on exactly the primitives the cart drawer uses, and nothing else:
// the panel is a plain .m6pn element parked directly under #root, opened with
// openPanel() and closed with hidePanels(). Geometry, the slide-in, the
// backdrop and the page scroll lock all come from the theme's own .m6pn rules
// (screen.css + async-panels.css), so the filter panel behaves - and looks -
// like the cart panel by construction rather than by a pile of overrides.
//
// Two layouts share this code, decided by the filters_layout section setting:
//   drawer  - #filters-aside carries .m6pn and is a panel at every width
//   static  - #filters-aside is an in-flow sidebar column on desktop and a
//             drawer below 1000px, driven by html.f8fl-open
// See FILTRE-NOTLARI.md for which template uses which.

const FILTERS_PANEL_ID = 'filters-aside';

// Every one of these is re-resolved on each call rather than captured once.
// The AJAX update replaces the panel's and the section's innerHTML, so any
// element reference held across an update points at a detached node - that is
// what made filtering stop working after the first change.
function filtersPanel() {
	return document.getElementById(FILTERS_PANEL_ID);
}

function filtersForm() {
	const panel = filtersPanel();
	return (panel && panel.querySelector('form.f8fl')) || document.querySelector('form.f8fl');
}

// The panel is only a modal when the section rendered it as one.
function filtersIsDrawer() {
	const panel = filtersPanel();
	return !!panel && panel.classList.contains('m6pn');
}

function filtersIsOpen() {
	const panel = filtersPanel();
	return (!!panel && panel.classList.contains('toggle')) || html_tag.classList.contains('f8fl-open');
}

// Put the panel where the cart panel lives. theme.liquid renders the cart as a
// direct child of #root; #filters-aside is authored inside the collection
// section instead, and that section sits inside <main id="content">, which
// screen.css gives "position: relative; z-index: 3". A positioned ancestor
// with a z-index forms a stacking context and nothing inside it can paint
// above something outside it - so the drawer stayed under the header whatever
// z-index it was given. Moving it out is the fix; raising z-index is not.
function filtersRelocate() {
	const panel = filtersPanel();
	const root = document.getElementById('root');
	if (!panel || !root) return;
	// Static layout keeps its sidebar in the document flow - moving it would
	// tear the desktop two-column layout apart.
	if (!panel.classList.contains('m6pn')) return;
	if (panel.parentElement !== root) {
		root.appendChild(panel);
	}
}

// Adds the close link and the per-group collapse handles the CSS expects.
// Safe to call repeatedly: each addition is guarded, so a re-render restores
// what was lost without doubling anything up.
function filtersDecorate() {
	const form = filtersForm();
	if (!form) return;
	// append_url is a custom.js global. custom.js only loads on the first user
	// interaction (or a load+idle/timeout fallback), so it can still be missing
	// the moment this runs. Bailing out here - rather than letting the append_url
	// call below throw - is what makes the retries below actually retry: an
	// uncaught throw here would abort this function permanently for whichever
	// caller invoked it (initFiltersEvt / filtersEvt both dispatch synchronously
	// at page load, almost always before custom.js has loaded), leaving every
	// group with no click target at all - no toggle link ever gets added, so
	// nothing opens or closes and every value stays exactly as CSS defaults it.
	if (typeof append_url !== 'function') return;

	// href '#filter' rather than the default './' so a click landing before the
	// handlers are bound cannot navigate away to /collections/.
	if (!form.querySelector(':scope > a.f8fl-toggle')) {
		append_url(form, 'Close', 'f8fl-toggle', '#filter');
	}

	// Only actual collapsible groups (the ones filters-sorting.liquid marks with
	// data-filter-toggle: sort_by, stok-durumu, price, each list/boolean filter).
	// The panel's own <h3> title in <header> is an h1-h6 too but carries no
	// data-filter-toggle and has no group to collapse - decorating it added a
	// chevron next to "Mevcut Filtreleriniz" / "Filtrele" that did nothing but
	// sit there next to the panel's real close (X) button.
	Array.from(form.querySelectorAll('h1[data-filter-toggle], h2[data-filter-toggle], h3[data-filter-toggle], h4[data-filter-toggle], h5[data-filter-toggle], h6[data-filter-toggle]')).forEach(function (heading) {
		if (!heading.querySelector(':scope > a.header-toggle')) {
			append_url(heading, 'Close', 'header-toggle');
		}
	});

	// The static layout's filter button is a plain in-page anchor; tag it so the
	// one delegated open handler below covers both layouts.
	Array.from(document.querySelectorAll('a[href="#filter"]')).forEach(function (link) {
		link.classList.add('f8fl-toggle');
	});

	Array.from(document.getElementsByClassName('f8fl-toggle')).forEach(function (link) {
		link.setAttribute('aria-controls', 'filter');
	});
}

function filtersOpen() {
	const panel = filtersPanel();
	if (!panel) return;

	if (typeof new_css === 'function') {
		new_css('css-filters', window.filepaths['async_filters_css']);
		new_css('css-search', window.filepaths['async_search_css']);
	}
	html_tag.classList.add('has-filters');

	if (filtersIsDrawer()) {
		// The cart's exact path: openPanel() owns the toggle class, the tab
		// order, the backdrop and the scroll lock.
		if (typeof openPanel === 'function') {
			openPanel(FILTERS_PANEL_ID);
		}
	} else {
		// Static layout below 1000px. hidePanels() first so an open cart or nav
		// panel does not stay stacked underneath.
		if (typeof hidePanels === 'function') {
			hidePanels();
		}
		html_tag.classList.add('f8fl-open');
		if (typeof getStickyFooters === 'function') {
			getStickyFooters();
		}
	}
}

function filtersClose() {
	// Both are cleared unconditionally. Leaving either behind keeps the scroll
	// lock on <html> with nothing open, which reads as a frozen page.
	if (typeof hidePanels === 'function') {
		hidePanels();
	}
	html_tag.classList.remove('f8fl-open');
}

// A price range still spanning its full extent is not a filter. Submitting it
// pins min/max into the URL, and every later render then inherits those bounds
// as if the shopper had chosen them.
function filtersNormaliseRange(form) {
	const min = form.querySelector('input#min');
	const max = form.querySelector('input#max');
	if (!min || !max) return;
	if (min.value === min.getAttribute('min') && max.value === max.getAttribute('max')) {
		min.removeAttribute('name');
		max.removeAttribute('name');
	}
}

function filtersClearRange(form) {
	const min = form.querySelector('input#min');
	const max = form.querySelector('input#max');
	if (min) min.removeAttribute('name');
	if (max) max.removeAttribute('name');
}

function filtersClearAll(form) {
	filtersClearRange(form);
	Array.from(form.querySelectorAll('input[type="checkbox"]:checked')).forEach(function (input) {
		input.checked = false;
	});
}

// Which groups the shopper had expanded, so the re-render can put them back.
function filtersCaptureState(form) {
	return {
		openGroups: Array.from(form.querySelectorAll('h1, h2, h3, h4, h5, h6'))
			.filter(el => el.classList.contains('toggle') && el.dataset.filterToggle)
			.map(el => el.dataset.filterToggle),
		expandedLists: Array.from(form.querySelectorAll('ul[data-filter-toggle].link-more-clicked'))
			.map(el => el.dataset.filterToggle)
			.filter(Boolean)
	};
}

function filtersRestoreState(state) {
	const form = filtersForm();
	if (!form) return;

	state.openGroups.forEach(function (name) {
		const heading = form.querySelector('h1[data-filter-toggle="' + name + '"], h2[data-filter-toggle="' + name + '"], h3[data-filter-toggle="' + name + '"], h4[data-filter-toggle="' + name + '"], h5[data-filter-toggle="' + name + '"], h6[data-filter-toggle="' + name + '"]');
		if (heading) heading.classList.add('toggle');
	});

	if (typeof linkMore === 'function') {
		linkMore();
	}

	// Re-expanding is a click, because that is the only entry point linkMore()
	// exposes. Guarded because a filter group can disappear entirely once the
	// result set narrows.
	state.expandedLists.forEach(function (name) {
		const trigger = form.querySelector('ul[data-filter-toggle="' + name + '"] a.link-more');
		if (trigger) trigger.click();
	});
}

// The theme rebuilds a lot of behaviour from scratch after markup is replaced.
// This is the same set the cart's handleCartPanel() fires, plus the
// collection-grid specific ones.
function filtersRefreshBindings() {
	window.dispatchEvent(collectionSortEvt);
	window.dispatchEvent(rangeSliderEvt);
	window.dispatchEvent(filtersEvt);
	window.dispatchEvent(modulePanelEvt);
	window.dispatchEvent(ratingsEvt);
	window.dispatchEvent(semanticInputEvt);
	window.dispatchEvent(semanticSelectEvt);
	window.dispatchEvent(schemeTooltipEvt);
	window.dispatchEvent(popupsEvt);
	window.dispatchEvent(collectionLoadMoreEvt);
	window.dispatchEvent(listScrollableEvt);
	window.dispatchEvent(modulePanelAnchorEvt);
	window.dispatchEvent(productcardVariantsEvt);
	window.dispatchEvent(listCollectionSliderEvt);
	window.dispatchEvent(heightLimitEvt);
	window.dispatchEvent(navAsideEvt);
	if (typeof window.check_limit_event === 'function') window.check_limit_event();
	if (typeof ajaxCart !== 'undefined') ajaxCart.init();
	if (typeof quickShop !== 'undefined') quickShop.init();
}

// Guards against an out-of-order response: a slow early request must not
// overwrite the result of a later one. Ticking boxes quickly used to leave the
// grid showing whichever response happened to land last.
let filtersRequestToken = 0;

function filtersApply() {
	const form = filtersForm();
	if (!form) return;

	const template = form.dataset.template;
	const section = template && document.getElementById('shopify-section-' + template);
	if (!section) return;

	const panel = filtersPanel();
	const rootEl = document.getElementById('root');
	// Only a relocated drawer needs the split treatment below; a static sidebar
	// is replaced wholesale along with the rest of the section.
	const relocated = !!panel && !!rootEl && panel.parentElement === rootEl;

	filtersNormaliseRange(form);

	const params = new URLSearchParams(new FormData(form)).toString();
	const url = window.location.pathname + '?section_id=' + template + (params ? '&' + params : '');

	const state = filtersCaptureState(form);
	const scrollTop = panel ? panel.scrollTop : 0;
	const wasOpen = filtersIsOpen();

	const token = ++filtersRequestToken;
	form.classList.add('processing');
	const grid = section.querySelector('.l4cl:not(.bls)');
	if (grid) grid.classList.add('processing');

	fetch(url)
		.then(function (response) {
			if (!response.ok) throw new Error('Filter request failed: ' + response.status);
			return response.text();
		})
		.then(function (text) {
			if (token !== filtersRequestToken) return;

			const parsed = new DOMParser().parseFromString(text, 'text/html');
			const newSection = parsed.querySelector('#shopify-section-' + template);
			if (!newSection) return;

			// The response carries its own copy of the drawer, still inside the
			// section. Lift it out of the section markup before the swap: leaving
			// it there would put a second #filters-aside into the document, and
			// every lookup by id would then resolve to whichever came first -
			// the stale one that is about to be discarded.
			const newPanel = newSection.querySelector('#' + FILTERS_PANEL_ID);
			if (newPanel && relocated) {
				newPanel.remove();
			}

			section.innerHTML = newSection.innerHTML;

			if (newPanel && relocated && panel) {
				panel.innerHTML = newPanel.innerHTML;
				// openPanel() only adds the close link when it opens the panel, so
				// an update while the panel is already open would leave it without
				// one. Guarded like every other custom.js call here: a throw would
				// skip filtersRestoreState/filtersDecorate/filtersRefreshBindings
				// below, not just this line.
				if (typeof append_url === 'function') {
					append_url(panel, 'Close', 'm6pn-close');
				}
			}

			filtersRestoreState(state);
			filtersDecorate();
			filtersRefreshBindings();

			const currentPanel = filtersPanel();
			if (currentPanel) {
				// Set after the restore, not before: linkMore() and the group
				// re-expansion both change the content height, and assigning
				// scrollTop against the shorter intermediate layout gets clamped.
				currentPanel.scrollTop = scrollTop;
			}

			// Only reposition the page when the panel is closed. While it is open
			// the shopper is still ticking boxes and every tick lands here -
			// scrolling the grid on each one reads as "the page jumps".
			if (!wasOpen) {
				const wrapper = document.querySelector('.collection-wrapper');
				if (wrapper) {
					wrapper.scrollIntoView();
				} else {
					window.scrollTo(0, 0);
				}
			}

			history.pushState({ params: params }, '', window.location.pathname + (params ? '?' + params : ''));

			// The re-render can drop the panel these classes describe. Left behind
			// they keep the scroll lock on with nothing open.
			if (!document.querySelector('.m6pn.toggle') && !html_tag.classList.contains('f8fl-open')) {
				html_tag.classList.remove('m6pn-open', 'm6cp-open');
			}
		})
		.catch(function (error) {
			console.warn('filtersApply error', error);
		})
		.then(function () {
			if (token !== filtersRequestToken) return;
			const activeForm = filtersForm();
			if (activeForm) activeForm.classList.remove('processing');
			const activeGrid = section.querySelector('.l4cl:not(.bls)');
			if (activeGrid) activeGrid.classList.remove('processing');
		});
}

// Bound once, on document, at script level. Delegation is what makes this
// survive the innerHTML swaps - there is nothing to re-bind after an update,
// which is the failure mode the previous implementation kept hitting.
function filtersHandleActivate(event) {
	const target = event.target;

	// Self-heal: the first decoration attempt (initFiltersEvt / filtersEvt, both
	// dispatched synchronously at page load) silently no-ops whenever custom.js
	// has not loaded yet - virtually always true at load, since custom.js only
	// loads on interaction or a load+idle fallback. Retrying here, on every
	// click into the panel, means the links exist by the time it matters: this
	// same click may be the interaction that just triggered custom.js to start
	// loading, but the one after it (opening the drawer, then picking a group)
	// will not race it. Guarded and idempotent inside filtersDecorate() itself,
	// so calling it unconditionally here costs nothing once already decorated.
	filtersDecorate();

	// Open / close.
	const toggleLink = target.closest('a.f8fl-toggle, a[aria-controls="filter"], a[href="#filter"]');
	if (toggleLink) {
		// Stop the navigation first: if anything below throws, the browser must
		// not follow the href off the collection page.
		event.preventDefault();
		if (toggleLink.closest('.f8fl')) {
			// The close link the decorator appends inside the form.
			filtersClose();
		} else if (filtersIsOpen()) {
			filtersClose();
		} else {
			filtersOpen();
		}
		return;
	}

	// Backdrop, for the static layout. The .m6pn backdrop is already handled by
	// custom-async.js, which closes on a.m6pn-close.
	if (html_tag.classList.contains('f8fl-open') && target.closest('.overlay-close')) {
		event.preventDefault();
		filtersClose();
		return;
	}

	const form = filtersForm();
	if (!form) return;

	// Clear links.
	const clearLink = target.closest('.f8fl a.remove-all, .f8fl a.clear-range');
	if (clearLink) {
		event.preventDefault();
		if (clearLink.classList.contains('remove-all')) {
			filtersClearAll(form);
		} else {
			filtersClearRange(form);
		}
		filtersApply();
		return;
	}

	// Group collapse handles. Matches the heading itself, not only the
	// decorator's appended link: on the very first click into a freshly
	// decorated panel the click still targets whatever was actually in the DOM
	// at click time, which is the bare heading if filtersDecorate() above just
	// added the link a moment too late to be what was clicked.
	// Scoped to [data-filter-toggle], same as filtersDecorate(): the panel's
	// own <h3> title has no group to collapse and must stay inert.
	const headingHandle = target.closest('.f8fl a.header-toggle, .f8fl h1[data-filter-toggle], .f8fl h2[data-filter-toggle], .f8fl h3[data-filter-toggle], .f8fl h4[data-filter-toggle], .f8fl h5[data-filter-toggle], .f8fl h6[data-filter-toggle]');
	if (headingHandle) {
		const heading = headingHandle.matches('h1, h2, h3, h4, h5, h6') ? headingHandle : headingHandle.closest('h1, h2, h3, h4, h5, h6');
		if (heading) {
			event.preventDefault();
			// Inlined rather than calling custom-async.js's toggle_dropdowns_simple:
			// that function can still be unloaded at this exact click (same load-race
			// as append_url/new_css above), and unlike those two this one has no
			// cheap fallback behaviour worth guarding around - toggling a class is
			// the entire function, so there is nothing to gain from the dependency.
			heading.classList.toggle('toggle');
			if (heading.classList.contains('toggle') && typeof runPaddingsForInputs === 'function') {
				Array.from(nextUntil(heading, 'h1, h2, h3, h4, h5, h6')).forEach(function (el) {
					Array.from(el.querySelectorAll('[class*="input-"][class*="fix"]')).forEach(runPaddingsForInputs);
				});
			}
		}
		return;
	}

	// Each filter value is a checkbox wrapped in a label that also contains the
	// no-JS fallback link. Without this the link wins and the browser does a
	// full page load instead of an AJAX update.
	const valueLink = target.closest('.f8fl .check label a');
	if (valueLink) {
		event.preventDefault();
		const label = valueLink.closest('label');
		const input = label && label.getAttribute('for') && document.getElementById(label.getAttribute('for'));
		if (input) {
			input.checked = !input.checked;
			input.dispatchEvent(new Event('change', { bubbles: true }));
		}
	}
}

document.addEventListener('click', filtersHandleActivate);
document.addEventListener('keyup', function (event) {
	if (event.key === ' ') {
		filtersHandleActivate(event);
	}
});

// Covers checkboxes, the mobile sort_by radios and the price inputs in one go.
document.addEventListener('change', function (event) {
	if (event.target.closest('form.f8fl')) {
		filtersApply();
	}
});

// Escape and the backdrop are handled by custom-async.js for .m6pn panels;
// this covers the static layout's drawer.
document.addEventListener('keydown', function (event) {
	if (event.key === 'Escape' && html_tag.classList.contains('f8fl-open')) {
		filtersClose();
	}
});

const initFiltersEvt = new CustomEvent("initFilters");
window.addEventListener("initFilters", function (evt) {
	if (!filtersForm()) return;
	// Relocate/decorate first: both are safe before custom.js loads (guarded
	// internally) and must not be skipped. new_css is a custom.js global and
	// was previously called first - if it threw (custom.js not loaded yet,
	// almost always true this early), the throw aborted this whole handler and
	// the two calls below never ran on page load at all, leaving every filter
	// group with no working toggle.
	filtersRelocate();
	filtersDecorate();
	if (typeof new_css === 'function') {
		new_css('form-validation-css', window.filepaths['async_validation_css']);
	}
});
window.dispatchEvent(initFiltersEvt);


const filtersEvt = new CustomEvent("filters");
window.addEventListener("filters", function(evt) {
	// Filter panel markup decoration only. Opening, closing and the AJAX
	// re-render all live in the filter drawer module further down - keeping them
	// out of this event is what stops handlers stacking up, because the event is
	// re-dispatched after every filter update.
	if (document.getElementsByClassName('f8fl').length) {
		html_tag.classList.add('t1cl');
		filtersDecorate();
	}

	var form_sort = document.getElementsByClassName('f8sr'),
			form_sort_list_view,
			form_sort_list_inline;

	function clearSortForm() {
		Array.from(form_sort).forEach((el) => {
			el.classList.remove('fixed');
			html_tag.classList.remove('f8sr-fixed');
		});
	}

	if (form_sort.length) {
		Array.from(form_sort).forEach(function (form_cont) {
			html_tag.classList.add('t1cl');
			if (form_cont.classList.contains('mobile-sticky') || form_cont.classList.contains('sticky')) {
				const trickDiv = createElementWithClass('div', 'offset-dist');
				const trickDist = createElementWithClass('div', 'inner-dist');

				function updateTrickDistHeight(div) {
					if (!div || div.hasHeight || !form_cont) return;
			
					requestAnimationFrame(() => {
						const h = form_cont.offsetHeight;
						div.style.height = `${h}px`;
						root_styles.style.setProperty('--f8sr_height', `${h}px`);
						div.hasHeight = true;
					});
				}
		
				//let updateSearchHeightExecuted = false;
				let updateSearchHeightRAF = 0;
		
				function applySearchHeight() {
					updateSearchHeightRAF = 0;
					if (!search_id) return;
			
					const h = search_id.clientHeight;
					if (h <= 0) return;
			
					root_styles.style.setProperty('--search_height', `${h}px`);
					//updateSearchHeightExecuted = true;
				}
		
				function updateSearchHeight() {
					if (!updateSearchHeightRAF) {
						updateSearchHeightRAF = requestAnimationFrame(applySearchHeight);
					}
				}

				function createEventListeners(element) {
					window.addEventListener('scroll', function () {
						updateTrickDistHeight(element);
						updateSearchHeight();
					});
					/*window.addEventListener('resize', throttle(() => {
						updateTrickDistHeight(element);
						updateSearchHeightExecuted = false;
						updateSearchHeight();
					}, 500));
					window.addEventListener('touchstart', function () {
						updateTrickDistHeight(element);
						updateSearchHeight();
					});
					window.addEventListener('keyup', function () {
						updateTrickDistHeight(element);
						updateSearchHeight();
					});*/
				}
	

				const observer = new IntersectionObserver(
						([e]) => {
							const boundingRect = e.boundingClientRect;

							if (e.isIntersecting) {
								//console.log('Element - on screen.');
								const el_mod = form_cont.classList.contains('sticky') ? e.target.nextElementSibling : form_cont;
								el_mod.classList.remove('fixed');
								html_tag.classList.remove('f8sr-fixed');
							} else {
								const el_mod = form_cont.classList.contains('sticky') ? e.target.nextElementSibling : form_cont;
								if (boundingRect.top < 0) {
									// console.log('Element - above screen.');
									el_mod.classList.add('fixed');
									html_tag.classList.add('f8sr-fixed');
								}
								if (boundingRect.bottom >= window.innerHeight) {
									// console.log('Element - below screen.');
									el_mod.classList.remove('fixed');
									html_tag.classList.remove('f8sr-fixed');
								}
							}
						}, {
							threshold: [0, 1],
							rootMargin: "0px 0px 0px 0px"
						}
				);

				if (form_cont.classList.contains('sticky')) {
					const trg = form_cont;

					trickDist.classList.add('before-f8sr');
					form_cont.after(trickDiv);
					form_cont.before(trickDist);

					createEventListeners(form_cont.nextElementSibling);

					observer.observe(form_cont.previousElementSibling);
				} else if (form_cont.classList.contains('mobile-sticky') && form_cont.classList.contains('mobile-compact')) {
					const trg = form_cont.querySelector('.link-btn');

					if (trg) {
						if (trg.classList.contains('mobile-hide')) {
							form_cont.classList.add('btn-mobile-hide');
						}
					}

					form_cont.prepend(trickDiv);
					form_cont.prepend(trickDist);

					createEventListeners(form_cont.querySelector('.inner-dist'));

					observer.observe(form_cont.querySelector('.offset-dist'));
					if (trg !== undefined && trg !== null) {
						const clone_me = trg.cloneNode(true);
						clone_me.classList.add('clone');
						insertAfter(trg, clone_me);
					}
				}
			}
			form_sort_list_view = Array.from(form_cont.getElementsByClassName('l4vw'));
			form_sort_list_inline = Array.from(form_cont.getElementsByClassName('l4in'));
			let form_view_inputs = form_sort_list_view.concat(form_sort_list_inline);

			if (form_view_inputs.length) {
				Array.from(form_view_inputs).forEach(function (el) {
					if (el.getAttribute('aria-controls') !== null) {
						var im = el,
								view_list = document.getElementById(im.getAttribute('aria-controls'));
						el.querySelectorAll('input').forEach(function (el) {
							el.parentElement.addEventListener('click', function (e) {
								let className = '';
								if (el.getAttribute('data-width')) {
									view_list.classList.remove('w100', 'w50', 'w33', 'w25','w20');
									saveCollectionview('collection_grid_view', el.getAttribute('data-width'));
									className = el.getAttribute('data-width');
									view_list.classList.add(className);
								} else if (el.getAttribute('data-width-mobile')) {
									view_list.classList.remove('w100-mobile', 'w50-mobile');
									saveCollectionview('collection_grid_view_mobile', el.getAttribute('data-width-mobile'));
									className = el.getAttribute('data-width-mobile');
									view_list.classList.add(className);
								}
								else if (el.getAttribute('data-collection_img_view')) {
									let collection_img_view = el.getAttribute('data-collection_img_view');
									saveCollectionview('collection_img_view', collection_img_view);
									if(document.querySelector('li picture.slider') != null) {
										view_list.querySelectorAll('li picture.slider').forEach(function (el) {
											if(el.firstChild.nodeName == 'DIV') {
												if (collection_img_view != 'first') {
													if(el.querySelectorAll('.second-first').length) {
														el.children[0].swiper.slideTo(0, 0, false);
													} else {
														el.children[0].swiper.slideTo(1, 0, false);
													}
												} else {
													if(el.querySelectorAll('.second-first').length) {
														el.children[0].swiper.slideTo(1, 0, false);
													} else {
														el.children[0].swiper.slideTo(0, 0, false);
													}
												}
											} else {
												if (collection_img_view != 'first') {
													let img = el.querySelector('img[data-index="2"]');
													if(img.closest('a') !== null) {
														img = img.closest('a');
													}
													el.prepend(img);
												} else {
													let img = el.querySelector('img[data-index="1"]');
													if(img.closest('a') !== null) {
														img = img.closest('a');
													}
													el.prepend(img);
												}
											}
										});
									} else {
										view_list.querySelectorAll('li picture + picture').forEach(function (el) {
											if (collection_img_view != 'first') {
												el.closest('li').classList.add('second-img-first');
											} else {
												el.closest('li').classList.remove('second-img-first');
											}
										});
									}

								}
							});
						});
					}
				});
			}
		});
	}
});
window.dispatchEvent(filtersEvt);


const collectionLoadMoreEvt = new CustomEvent("collectionLoadMore");
window.addEventListener("collectionLoadMore", function (evt) {
	var collection_load_more = document.querySelectorAll('#load-more-button[data-next], #load-more-button[data-prev]');
	if (collection_load_more) {
		Array.from(collection_load_more).forEach(function (button) {
			button.addEventListener('click', function(e) {
				e.preventDefault();
				var template = button.getAttribute('data-section'),
						collectionSection = document.getElementById('shopify-section-' + template),
						curr_products = collectionSection.querySelector('.results, .l4cl:not(.bls, .category)'),
						pagination_info = document.getElementById('load-more-info');
				if (button.getAttribute('data-next') != null) {
					var direction = 'next'
				} else {
					var direction = 'prev';
				}
				button.classList.add('loading');
				fetch(button.getAttribute('href'))
						.then((response) => {
							if (!response.ok) {
								var error = new Error(response.status);
								throw error;
							}
							return response.text();
						})
						.then((text) => {
							const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-' + template);
							var	new_products = resultsMarkup.querySelector('.results, .l4cl:not(.bls, .category)'),
									new_button = resultsMarkup.querySelector('#load-more-button[data-'+ direction +'], #load-more-button[data-top]'),
									new_pagination_info = resultsMarkup.querySelector('#load-more-info');

							if (direction == 'prev'){
								var lastScrollHeight = curr_products.scrollHeight;
							}
							if (curr_products && new_products) {
								if (direction == 'next') {
									Array.from(new_products.children).forEach(function (el) {
										curr_products.appendChild(el);
									});
								} else {
									Array.from(new_products.children).reverse().forEach(function (el) {
										curr_products.insertBefore(el, curr_products.firstChild);
									});
								}
							}
							if (direction == 'next' && pagination_info && pagination_info.parentNode && new_pagination_info) {
								pagination_info.parentNode.replaceChild(new_pagination_info, pagination_info);
							}
							if (button && button.parentNode && new_button) {
								button.parentNode.replaceChild(new_button, button);
							} else if (button && direction == 'prev') {
								button.parentNode.remove();
							}
							if (direction == 'prev'){
								var scrollDiff = curr_products.scrollHeight - lastScrollHeight,
										scrollTo = curr_products.scrollTop += scrollDiff;
								window.scrollTo({
									top: scrollTo,
									behavior: 'instant',
								});
							}
							window.history.replaceState({}, '', button.getAttribute('href'));
							saveLoadMoreAnchor();
							window.dispatchEvent(ratingsEvt);
							window.dispatchEvent(semanticInputEvt);
							window.dispatchEvent(schemeTooltipEvt);
							window.dispatchEvent(popupsEvt);
							window.dispatchEvent(collectionLoadMoreEvt);
							window.dispatchEvent(listScrollableEvt);
							window.dispatchEvent(productVariantsEvt);
							window.dispatchEvent(formZindexEvt);
							window.dispatchEvent(semanticSelectEvt);
							window.check_limit_event();
							ajaxCart.init();
							quickShop.init();
						})
						.catch((error) => {
							console.log("collectionLoadMore error", error);
							throw error;
						});
			});
		});
	}
});
window.dispatchEvent(collectionLoadMoreEvt);

// Collectionpage: sort_by
const collectionSortEvt = new CustomEvent("collectionSort")
window.addEventListener("collectionSort", function (evt) {
	var sort_by = document.getElementById('sort_by'),
			sort_by_clone = document.getElementsByClassName('sort_by_clone')[0];
	if (sort_by != null) {
		Shopify.queryParams = [];
		if (location.search.length) {
			for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
				aKeyValue = aCouples[i].split('=');
				if (aKeyValue.length > 1) {
					Shopify.queryParams.push({
						key: decodeURIComponent(aKeyValue[0]),
						value: decodeURIComponent(aKeyValue[1])
					});
				}
			}
		}
		sort_by.addEventListener('change', function() {
			var el = this;
			if (sort_by_clone != null) { sort_by_clone.value == el.value; }
			setTimeout(function () {
				function findIndexByProperty(data, key, value) {
					for (var i = 0; i < data.length; i++) {
						if (data[i][key] == value) {
							return i;
						}
					}
					return -1;
				}
				var sort_by =  {
					key: 'sort_by',
					value: el.value
				};
				var sort_by_index = findIndexByProperty(Shopify.queryParams, 'key', 'sort_by');
				if (sort_by_index > -1) {
					Shopify.queryParams[sort_by_index] = sort_by;
				} else {
					Shopify.queryParams.push(sort_by);
				}
				var url = '';
				for (var i = 0; i < Shopify.queryParams.length; i++) {
					url += encodeURIComponent(Shopify.queryParams[i].key) + '=' + Shopify.queryParams[i].value;
					if (i < Shopify.queryParams.length - 1) {
						url += '&';
					}
				}
				location.search = url;
			},1);
		});
	}
});
window.dispatchEvent(collectionSortEvt);
